import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  //La clase apexcharts-tooltip se usa para trasladar el tooltip del donutChart
  .apexcharts-tooltip {
    transform: translateX(0px) translateY(0px);
  }
`;

export { Container, Wrapper };
